import { useNavigate } from "react-router-dom";
import TabelaDocumentos from "../component/TabelaDocumentos";
import useApp from "../context/AppContext";
import { FaSearch } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import Header from "../component/Header";
import { api } from "../utils/api";

type StatusFilter = {
  [name: string]: boolean;
};
const StatusFilterDefault = {
  Nova: true,
  "Em análise": true,
  Cancelada: false,
  Reprovada: true,
  Finalizada: true,
};

const ListaDocumentos = () => {
  const { usuario, setUsuario, showModalError, setLoading, verificaUser, loaded } = useApp();
  const navigate = useNavigate();
  const [showTipoDrop, setShowTipoDrop] = useState(false);
  const [tipoFilter, setTipoFilter] = useState("");
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [statusFilter, setStatusFilter] = useState<StatusFilter>(StatusFilterDefault);
  const [filter, setFilter] = useState("");

  const statusArray = Object.keys(statusFilter).map((key) => {
    if (statusFilter[key]) return key;
  });
  const refStatus = useRef<HTMLUListElement>(null);
  const refTipo = useRef<HTMLUListElement>(null);
  const listaDocumentos = () => {
    setLoading(true);
    api(usuario)
      .get("/notasServico/listarNotas")
      .then((resp) => {
        if (resp.status === 200) {
          setLoading(false);
          console.log(resp.data)
          setUsuario({ ...usuario, documentos: resp.data });
        } else {
          setLoading(false);
          showModalError(resp.data);
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response?.status === 406) {
          localStorage.clear();
          navigate("/login");
        } else showModalError("Erro ao acessar servidor");
      });
  };
  // ROTINA PARA FECHAR O POPUP DO FILTRO POR STATUS QUANDO CLICAR FORA DO ELEMENTO
  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (showStatusDrop && refStatus.current && !refStatus.current.contains(e.target)) {
        setTimeout(() => {
          setShowStatusDrop(false);
        }, 100);
      }
      if (showTipoDrop && refTipo.current && !refTipo.current?.contains(e.target)) {
        setTimeout(() => {
          setShowTipoDrop(false);
        }, 100);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showStatusDrop, showTipoDrop]);

  useEffect(() => {
    if (loaded) {
      verificaUser();
      if (!usuario.accessToken) navigate("/login");
      else listaDocumentos();
    }
  }, [usuario.accessToken, usuario.id, loaded]);
  const ListaStatus = () => {
    return (
      <ul ref={refStatus} className={`dropdown-menu dropdown-width ${showStatusDrop ? "show" : ""}`}>
        {Object.keys(StatusFilterDefault).map((status) => (
          <li
            key={status}
            onClick={() => {
              setStatusFilter({ ...statusFilter, [status]: !statusFilter[status] });
            }}
          >
            <div className="form-check form-check-inline check-status">
              <input
                className="form-check-input m-0"
                type="checkbox"
                id="novas"
                checked={statusFilter[status]}
                onChange={(e) => {
                  e.target.checked = !statusFilter[status];
                }}
              />
            </div>
            <label className="lbl-status">{status}</label>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <div className="limiter altbg4">
      <div className="container-interna">
        <div className="wrap-interna p-t-25 p-b-20">
          <Header />

          <div>
            {!(usuario.documentos === undefined || usuario.documentos.length === 0) && (
              <div className="titulo-tabela bloco-tabela-ferramentas-wrap">
                <div className="bloco-tabela-ferramentas-titulo">
                  <h1>Consulta de Notas Fiscais e Faturas de Serviço</h1>
                </div>
                <div className="bloco-tabela-ferramentas">
                  <div className="dropdown drop-class">
                    <button
                      className="btn btn-secondary dropdown-toggle dropdownbtn"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={() => {
                        if (!showTipoDrop) {
                          setShowTipoDrop(true);
                        }
                      }}
                    >
                      Tipo
                    </button>
                    <ul ref={refTipo} className={`dropdown-menu ${showTipoDrop ? "show" : ""}`}>
                      <li
                        className="dropdown-item"
                        onClick={() => {
                          setTipoFilter("");
                          setShowTipoDrop(false);
                        }}
                      >
                        <button className="dropdown-item">Todas</button>
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={() => {
                          setTipoFilter("Nota Fiscal");
                          setShowTipoDrop(false);
                        }}
                      >
                        <button className="dropdown-item">Nota Fiscal</button>
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={() => {
                          setTipoFilter("Fatura");
                          setShowTipoDrop(false);
                        }}
                      >
                        <button className="dropdown-item">Fatura</button>
                      </li>
                    </ul>
                  </div>

                  <div id="dropdown" className="dropdown drop-class">
                    <button
                      className={`btn btn-secondary dropdown-toggle dropdownbtn`}
                      onClick={() => {
                        if (!showStatusDrop) {
                          setShowStatusDrop(true);
                        }
                      }}
                    >
                      Status da nota
                    </button>
                    <ListaStatus />
                  </div>

                  <div className="container py-2">
                    <div className="row">
                      <div className="input-group col-md-12 busca-wrap">
                        <input
                          className="form-control py-2 rounded-only-left"
                          placeholder="Pesquisar"
                          style={{ lineHeight: 1 }}
                          value={filter}
                          onChange={(e) => setFilter(e.currentTarget.value)}
                        />
                        <span className="input-group-append">
                          <button className="btn btn-outline-secondary rounded-only-right" type="button">
                            <FaSearch />
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <TabelaDocumentos filter={filter} statusArray={statusArray} tipoFilter={tipoFilter} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaDocumentos;
